import React from 'react';
import { Modal, Form, Button, Row, Col } from 'react-bootstrap';

const DEFAULT_CHALLENGE = {
    title: '',
    category: 'OSINT',
    description: '',
    file_link: '',
    flags: [{ name: 'Flag', value: '' }],
    difficulty: 'Medium'
};

function CreateChallengeModal({ show, onHide, newChallenge, setNewChallenge, createError, onCreate }) {
    const addFlag = () => {
        setNewChallenge({
            ...newChallenge,
            flags: [...newChallenge.flags, { name: '', value: '' }]
        });
    };

    const removeFlag = (index) => {
        if (newChallenge.flags.length > 1) {
            const newFlags = newChallenge.flags.filter((_, i) => i !== index);
            setNewChallenge({ ...newChallenge, flags: newFlags });
        }
    };

    const updateFlag = (index, field, value) => {
        const newFlags = [...newChallenge.flags];
        newFlags[index][field] = value;
        setNewChallenge({ ...newChallenge, flags: newFlags });
    };

    const handleClose = () => {
        onHide();
        setNewChallenge({ ...DEFAULT_CHALLENGE, flags: [{ name: 'Flag', value: '' }] });
    };

    return (
        <Modal show={show} onHide={handleClose} className="training-create-modal" size="lg">
            <Modal.Header closeButton className="training-create-header">
                <Modal.Title className="training-create-title">Create Challenge</Modal.Title>
            </Modal.Header>
            <Modal.Body className="training-create-body">
                <Form className="training-create-form">
                    {createError && <div className="training-error-message">{createError}</div>}
                    <Form.Group className="training-form-group">
                        <Form.Label>Title</Form.Label>
                        <Form.Control
                            type="text"
                            value={newChallenge.title}
                            onChange={(e) => setNewChallenge({ ...newChallenge, title: e.target.value })}
                            className="training-input"
                        />
                    </Form.Group>
                    <Form.Group className="training-form-group">
                        <Form.Label>Category</Form.Label>
                        <Form.Control
                            as="select"
                            value={newChallenge.category}
                            onChange={(e) => setNewChallenge({ ...newChallenge, category: e.target.value })}
                            className="training-select"
                        >
                            <option>OSINT</option><option>Pwn</option><option>Web</option>
                            <option>Reverse Engineering</option><option>Crypto</option><option>Forensics</option>
                            <option>Misc</option><option>Steganography</option><option>Binary Exploitation</option>
                            <option>Networking</option><option>Programming</option><option>Game Hacking</option>
                            <option>Full Pwn</option>
                        </Form.Control>
                    </Form.Group>
                    <Form.Group className="training-form-group">
                        <Form.Label>Difficulty</Form.Label>
                        <Form.Control
                            as="select"
                            value={newChallenge.difficulty}
                            onChange={(e) => setNewChallenge({ ...newChallenge, difficulty: e.target.value })}
                            className="training-select"
                        >
                            <option>Easy</option><option>Medium</option><option>Hard</option><option>Extreme</option>
                        </Form.Control>
                    </Form.Group>
                    <Form.Group className="training-form-group">
                        <Form.Label>Description (Supports Markdown formatting)</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={5}
                            value={newChallenge.description}
                            onChange={(e) => setNewChallenge({ ...newChallenge, description: e.target.value })}
                            className="training-textarea font-mono"
                            placeholder="# Your challenge description here&#10;* Supports **bold** and *italic* text&#10;* Creates clickable [links](https://example.com)"
                        />
                    </Form.Group>
                    <Form.Group className="training-form-group">
                        <Form.Label>File Link (Optional)</Form.Label>
                        <Form.Control
                            type="text"
                            value={newChallenge.file_link}
                            onChange={(e) => setNewChallenge({ ...newChallenge, file_link: e.target.value })}
                            className="training-input"
                        />
                    </Form.Group>

                    <Form.Group className="training-form-group">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <Form.Label>Flags</Form.Label>
                            <Button variant="outline-primary" size="sm" onClick={addFlag}>Add Flag</Button>
                        </div>
                        {newChallenge.flags.map((flag, index) => (
                            <div key={index} className="mb-3 p-3 border rounded">
                                <div className="d-flex justify-content-between align-items-start mb-2">
                                    <h6>Flag {index + 1}</h6>
                                    {newChallenge.flags.length > 1 && (
                                        <Button variant="outline-danger" size="sm" onClick={() => removeFlag(index)}>Remove</Button>
                                    )}
                                </div>
                                <Row>
                                    <Col md={6}>
                                        <Form.Label>Flag Name</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="e.g., User Flag, Root Flag"
                                            value={flag.name}
                                            onChange={(e) => updateFlag(index, 'name', e.target.value)}
                                            className="training-input"
                                        />
                                    </Col>
                                    <Col md={6}>
                                        <Form.Label>Flag Value</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Flag value"
                                            value={flag.value}
                                            onChange={(e) => updateFlag(index, 'value', e.target.value)}
                                            className="training-input"
                                        />
                                    </Col>
                                </Row>
                            </div>
                        ))}
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer className="training-create-footer">
                <Button variant="secondary" onClick={handleClose} className="training-cancel-button">Cancel</Button>
                <Button variant="primary" onClick={onCreate} className="training-create-submit">Create</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default CreateChallengeModal;
